<template>
  <div class="search">

        <div class="col">
        <div class="col-title">日期: </div>
        <el-date-picker class="date" v-bind="dateProps"
          :value="model.dateRange" @input="onInput('dateRange', $event)"/>
        </div>

        <div class="col-platform" >
        <div class="col-title">平台: </div>
        <el-select multiple collapse-tags reserve-keyword clearable filterable placeholder="不限" class="selector"
            v-model="model.platformIds">
            <el-option v-for="it in platformList" :label="it.name" :key="it.id" :value="it.id"/>
        </el-select>
        </div>

        <div class="col" v-if="showMedia">
        <div class="col-title">媒体: </div>
        <el-select multiple collapse-tags reserve-keyword clearable filterable :filter-method="filterMedia" placeholder="不限" class="selector"
            v-model="model.mediaIds" @visible-change="initMedia">
          <el-option v-for="item in mediaListFiltered" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        </div>

      <el-button v-if="!showAdzone" style="margin-left: 20px; font-size: 14px" type="primary" @click="$emit('search')" :disabled="loading">查询</el-button>

        <div class="col" style="display: block" v-if="showAdzone">
        <div class="col-title">广告位: </div>
        <el-select multiple collapse-tags reserve-keyword clearable filterable :filter-method="filterAdzone"  placeholder="不限" class="selector"
            v-model="model.adzoneIds" @visible-change="initAdzone">
          <el-option v-for="item in adzoneListFiltered" :key="item.adzoneId" :label="item.adzoneName" :value="item.adzoneId" />
        </el-select>

        <el-button v-if="showAdzone" style="margin-left: 20px; margin-top: 30px; font-size: 14px" type="primary" @click="$emit('search')" :disabled="loading">查询</el-button>
        </div>

    <div>

    </div>
  </div>
</template>

<script>
  import { dateProps } from './schedule-date-picker-props';
  import _ from 'lodash'

  export default {
    props: {
      loading: Boolean,
      adzoneList: Array,
      mediaList: Array,
      platformList: Array,
      showAdzone: Boolean,
      showMedia: Boolean,
      value: {
        type: Object,
        default: function () {
          return {
            dateRange: Array,
            platformIds: Array,
            mediaIds: Array,
          };
        }
      }
    },
    data: function () {
      return {
        dateProps: dateProps,
        mediaListFiltered: [],
        adzoneListFiltered: [],
      }
    },
    computed: {
      model: function () {
        return this.value || {};
      },
    },
    watch: {
      mediaList: function() {
        this.mediaListFiltered = _.cloneDeep(this.mediaList)
      },
      adzoneList: function() {
        this.adzoneListFiltered = _.cloneDeep(this.adzoneList)
      }
    },
    methods: {
      initMedia: function() {
        this.mediaListFiltered = _.cloneDeep(this.mediaList)
      },
      initAdzone: function() {
        this.adzoneListFiltered = _.cloneDeep(this.adzoneList)
      },
      onInput: function (key, val) {
        this.$emit('input', { ...this.model, [key]: val });
      },
      filterMedia: function (key) {
        if (key) {
          this.mediaListFiltered = _.filter(this.mediaList, (it) => (it.name && (it.name + "").includes(key)) || (it.id && (it.id + "").includes(key)))
        } else {
          this.mediaListFiltered = _.cloneDeep(this.mediaList)
        }
      },
      filterAdzone: function (key) {
        if (key) {
          this.adzoneListFiltered = _.filter(this.adzoneList, (it) => (it.adzoneName && (it.adzoneName + "").includes(key)) || (it.adzoneId && (it.adzoneId + "").includes(key)))
        } else {
          this.adzoneListFiltered = _.cloneDeep(this.adzoneList)
        }
      }
    }
  }
</script>

<style scoped>
 .col {
   display: inline-block;
   margin-left: 20px;
   /* margin-top: 20px; */
 }

.col-platform {
   display: inline-block;
   margin-left: 20px;
   margin-top: 20px;
   width: 210px;
 }

 .search .col-title {
   display: inline-block;
   margin-right: 5px;
   font-size: 14px;
 }

 .btn-search {
   height: 30px;
   font-size: 15px;
   width: 70px;
 }
.search >>> .el-input {
   width: 350px;
}


.col-platform >>> .el-input {
   width: 170px;
}

.selector >>> .el-input__inner {
   height: 32px;
}
</style>